export default {
  // Pass/fail
  COLOR_PASS: 100,
  COLOR_WARN: 101,
  COLOR_FAIL: 102,
  COLOR_NONE: 103,
  // Clouds
  COLOR_AWS: 200,
  COLOR_AZURE: 201,
  COLOR_GOOGLE: 202,
  COLOR_IBM: 203,
  COLOR_CHINAVPS: 204,
  COLOR_OPENHOST: 205,
  COLOR_OTHER: 206,
  COLOR_AKAMAI: 207,
};
